import * as React from 'react';

import { CustomIconProps, defaultIconProps } from './types';

export function DuplicateIcon({
  size = defaultIconProps.size,
  color = '#0000A3',
  className,
  ...props
}: CustomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path fill={color} d="M0 0H24V24H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M12.75 10.75h1.5v-2h2v-1.5h-2v-2h-1.5v2h-2v1.5h2v2zm-2 4h5.5v-1.5h-5.5v1.5zM8.308 18.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V3.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h6.942l5.25 5.25v9.942c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H8.308zm0-1.5h10.384a.294.294 0 00.212-.096.294.294 0 00.096-.212V7.5L14.5 3H8.308a.294.294 0 00-.212.096.294.294 0 00-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 00.212.096zm-4 5.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V7.5H4v13.192c0 .077.032.148.096.212a.294.294 0 00.212.096H14.5v1.5H4.308z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default DuplicateIcon;
